import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'travel-ui-vervotech-checkbox',
  templateUrl: './vervotech-checkbox.component.html',
  styleUrls: ['./vervotech-checkbox.component.scss']
})
export class VervotechCheckboxComponent implements OnInit {
  @Input() id = '';
  @Input() label = '';

  @Output() change = new EventEmitter();
  checkBoxForm?: UntypedFormGroup;
  checked = false;

  constructor(private formBuilder: UntypedFormBuilder) { }

  boxchecked(event: any) {
    this.change.emit(event);
  }

  ngOnInit() {
  }


}
